import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {
    initializationEducation,
    addEducationDocument,
    removeEducationDocument,
    saveEducationDocuments,
    unmountEducationDocuments,
} from '@componentDP/js_react/redux/actions/education';
import EducationDocument from "./education_document";
import {getDataListFromRefsList, getLabelType} from "@helpers/functions";
import LoadingDocuments from "../skeletons/loading_documents";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import DeleteConfirmDialog from './delete_confirm_dialog';
import {withTranslation} from "react-i18next";

class Education extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numExpandedPanel: 0,
            isOpenDeleteConfirmDialog: false,
            docUuidDeleteConfirmDialog: '',
        };
        this.addDocument = this.addDocument.bind(this);
        this.save = this.save.bind(this);
        this.handleChangePanel = this.handleChangePanel.bind(this);
        this.handleOpenDeleteConfirmDialog = this.handleOpenDeleteConfirmDialog.bind(this);
        this.handleCloseDeleteConfirmDialog = this.handleCloseDeleteConfirmDialog.bind(this);
        this.handleContinueDeleteConfirmDialog = this.handleContinueDeleteConfirmDialog.bind(this);
        const {initializationEducation} = this.props;
        initializationEducation();
    }
    addDocument() {
        const {addEducationDocument} = this.props;
        addEducationDocument();
    }
    save(refsList) {
        const {schemesEducationDocuments, saveEducationDocuments, t} = this.props;
        let dataList = getDataListFromRefsList(refsList, schemesEducationDocuments);
        if (dataList.length) {
            saveEducationDocuments(dataList, t);
        }
    }
    componentWillUnmount() {
        const {unmountEducationDocuments} = this.props;
        unmountEducationDocuments();
    }
    handleChangePanel = (numPanel) => {
        const state = this.state;
        this.setState({...state, numExpandedPanel: numPanel === state.numExpandedPanel ? -1 : numPanel});
    };
    handleOpenDeleteConfirmDialog(docUuid) {
        const state = this.state;
        this.setState({...state, isOpenDeleteConfirmDialog: true, docUuidDeleteConfirmDialog: docUuid});
    };
    handleCloseDeleteConfirmDialog() {
        const state = this.state;
        this.setState({...state, isOpenDeleteConfirmDialog: false, docUuidDeleteConfirmDialog: ''});
    };
    handleContinueDeleteConfirmDialog() {
        const {removeEducationDocument, t} = this.props;
        const state = this.state;
        removeEducationDocument(state.docUuidDeleteConfirmDialog, t);
        this.setState({...state, isOpenDeleteConfirmDialog: false, docUuidDeleteConfirmDialog: ''});
    };
    render() {
        const { classes, t } = this.props;
        const {
            addDocument,
            save,
            handleChangePanel,
            handleOpenDeleteConfirmDialog,
            handleCloseDeleteConfirmDialog,
            handleContinueDeleteConfirmDialog,
        } = this;
        const {numExpandedPanel, isOpenDeleteConfirmDialog} = this.state;
        const {
            educationDocuments,
            typesEducationDocuments,
            loadingEducationDocuments,
            loadedEducationDocuments,
        } = this.props;
        let refsList = [];
        return(
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" align={"left"}>{t('education')}</Typography>
                </Grid>
                <Grid item xs={12}>
                    {loadingEducationDocuments || !loadedEducationDocuments
                        ? <LoadingDocuments />
                        : <Grid container spacing={2}>
                            {educationDocuments.map((educationDocument, numEducationDocument) => {
                                refsList[numEducationDocument] = {};
                                const typeEducationDocument = getLabelType(educationDocument, typesEducationDocuments);
                                return (
                                    <Grid item xs={12} key={educationDocument.uuid}>
                                        <Accordion
                                            expanded={numExpandedPanel === numEducationDocument}
                                            onChange={() => {
                                                handleChangePanel(numEducationDocument);
                                            }}
                                            className={classes.panel}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <div className={classes.columnTitle}>
                                                    <Typography>
                                                        {typeEducationDocument
                                                            ? typeEducationDocument.value
                                                            : `${t('document')} ${numEducationDocument + 1}`}
                                                    </Typography>
                                                </div>
                                                <div className={`${classes.columnControl} ${classes.alignRight}`}>
                                                    <IconButton
                                                        aria-label="delete"
                                                        color="secondary"
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenDeleteConfirmDialog(educationDocument.uuid);
                                                        }}>
                                                        <Close />
                                                    </IconButton>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <input type="hidden" ref={input => refsList[numEducationDocument]['uuid'] = input} value={educationDocument.uuid} />
                                                <EducationDocument educationDocument={educationDocument} refs={refsList[numEducationDocument]} />
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12}>
                                <Button variant="outlined" size="small" onClick={addDocument}>{t('add_document')}</Button>
                            </Grid>
                            <Grid item xs={12} className={classes.alignRight}>
                                <Button variant="contained" color="primary" onClick={() => {save(refsList)}}>
                                    {t('save')}
                                </Button>
                            </Grid>
                        </Grid>}
                </Grid>
                <DeleteConfirmDialog
                    isOpen={isOpenDeleteConfirmDialog}
                    handleClose={handleCloseDeleteConfirmDialog}
                    handleContinue={handleContinueDeleteConfirmDialog} />
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        schemesEducationDocuments: state.schemesEducationDocuments,
        educationDocuments: state.educationDocuments,
        typesEducationDocuments: state.typesEducationDocuments,
        loadingEducationDocuments: state.loadingEducationDocuments,
        loadedEducationDocuments: state.loadedEducationDocuments,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        initializationEducation,
        addEducationDocument,
        removeEducationDocument,
        saveEducationDocuments,
        unmountEducationDocuments,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Education));
